<template>
  <div class="playing">
    <div class="playing-item"></div>
    <div class="playing-item"></div>
    <div class="playing-item"></div>
    <div class="playing-item"></div>
  </div>
</template>

<script>
export default {
  name: "PlayingIcon"
};
</script>

<style lang="scss" scoped>
.playing {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 18px;

  &-item {
    width: 2px;
    height: 8px;
    background: #e73828;
    border-radius: 2px 2px 0 0;
    transform-origin: 0 100%;

    &:nth-child(1) {
      animation: loading 0.5s ease 0s infinite;
    }

    &:nth-child(2) {
      animation: loading 0.5s linear 0.2s infinite;
    }

    &:nth-child(3) {
      animation: loading 0.5s linear 0.4s infinite;
    }

    &:nth-child(4) {
      animation: loading 0.5s linear 0.6s infinite;
    }

    @keyframes loading {
      0% {
        transform: scaleY(1);
      }

      10% {
        transform: scaleY(1.07);
      }

      20% {
        transform: scaleY(1.14);
      }

      30% {
        transform: scaleY(1.21);
      }

      50% {
        transform: scaleY(1.28);
      }

      60% {
        transform: scaleY(1.21);
      }

      70% {
        transform: scaleY(1.14);
      }

      80% {
        transform: scaleY(1.07);
      }

      90% {
        transform: scaleY(1);
      }

      100% {
        transform: scaleY(0.93);
      }
    }
  }
}
</style>
